// extracted by mini-css-extract-plugin
module.exports = {"modal":"ConfirmModal_modal__mf0E9","content":"ConfirmModal_content__MwiH4","actions":"ConfirmModal_actions__odooq","destructIcon":"ConfirmModal_destructIcon__U9BDK"};